import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskIndicatorPanel = ({ risks }) => {
  const getRiskLevelColor = (level) => {
    const colors = {
      'Tinggi': 'text-error bg-error/10 border-error/20',
      'Sedang': 'text-warning bg-warning/10 border-warning/20',
      'Rendah': 'text-success bg-success/10 border-success/20'
    };
    return colors?.[level] || 'text-muted-foreground bg-muted border-border';
  };

  const getRiskIcon = (category) => {
    const icons = {
      'Kapasitas': 'TrendingDown',
      'Kondisi': 'AlertTriangle',
      'Pemeliharaan': 'Wrench',
      'Investasi': 'DollarSign',
      'Operasional': 'Settings'
    };
    return icons?.[category] || 'AlertCircle';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center">
          <Icon name="AlertTriangle" size={20} color="var(--color-error)" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Indikator Risiko Peralatan</h3>
      </div>
      <div className="space-y-4">
        {risks?.map((risk) => (
          <div 
            key={risk?.id} 
            className={`rounded-xl p-4 border-2 ${getRiskLevelColor(risk?.level)}`}
          >
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center flex-shrink-0">
                <Icon name={getRiskIcon(risk?.category)} size={20} color="currentColor" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-2">
                  <div>
                    <span className="text-xs font-medium opacity-80 uppercase tracking-wide">
                      {risk?.category}
                    </span>
                    <h4 className="text-base font-semibold mt-1">{risk?.title}</h4>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-wide whitespace-nowrap">
                    {risk?.level}
                  </span>
                </div>

                <p className="text-sm opacity-90 mb-3">{risk?.description}</p>

                <div className="bg-card rounded-lg p-3 border border-current/20">
                  <p className="text-xs font-medium mb-2">Dampak:</p>
                  <ul className="space-y-1">
                    {risk?.impacts?.map((impact, index) => (
                      <li key={index} className="flex items-start gap-2 text-sm">
                        <Icon name="ChevronRight" size={16} className="flex-shrink-0 mt-0.5" />
                        <span>{impact}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {risk?.recommendation && (
                  <div className="mt-3 bg-card rounded-lg p-3 border border-current/20">
                    <div className="flex items-start gap-2">
                      <Icon name="Lightbulb" size={16} className="flex-shrink-0 mt-0.5" />
                      <div>
                        <p className="text-xs font-medium mb-1">Rekomendasi:</p>
                        <p className="text-sm">{risk?.recommendation}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskIndicatorPanel;